export default class PlaceConstraintsAll
{
    PlaceCheck(Temp, SentObjects,ActionType = "null")
        {
            var ActiveTab = SentObjects.Active;
            const scene = Temp.scene;
            const Constrain = scene.ConstraintObjects;
            var Passed = true;

            switch(ActiveTab.getData('TabName'))
            {
                case "PaintTray":

                    break;
                case "IcingTray":
                    Passed = NormalCheck(Temp, Constrain);

                    if (Passed)
                    {
                        IcingPlacement(Temp, Constrain.Cake);
                    } 
                    
                    break;
                case "PatternTray":
                    const TempBounds = Temp.getBounds();
                    const CakeBounds = Constrain.Cake.getBounds();

                    if (Phaser.Geom.Rectangle.Overlaps(TempBounds,CakeBounds))
                    {
                        Temp.setMask(scene.CakeMask);
                    }
                    else
                    {
                        Passed = false;
                    }
                    break;

                case "DecorTray":
                    Passed = NormalCheck(Temp, Constrain);
                    break;
 
                case "FlowerTray":
                    Passed = NormalCheck(Temp, Constrain);
                    break;

                case "CandleTray":
                    const BottomCenterPoint = Temp.getBottomCenter();
                    
                    if (scene.CandleArea.contains(BottomCenterPoint.x,BottomCenterPoint.y))
                    {
                        //console.log("on");
                    }
                    else
                    {
                        //console.log("off");
                        Passed = false
                    }
                    break;

                case "NumbersTray":
                    Passed = NormalCheck(Temp, Constrain);
                    break;

                case "LettersTray":
                    Passed = NormalCheck(Temp, Constrain);
                    break;
                default:
                    //console.log(ActiveTab.getData('TabName') + " is not a tab name");
                    break;
            }   

            if (Passed)//passed means placed correctly
            {
                if (ActionType === "null")//null means placed
                {
                    //console.log("Passed");
                    scene.SetItemData.SetItemData(Temp,SentObjects.Original,ActiveTab);
                    Temp.setInteractive();
                    scene.input.setDraggable(Temp);
                    if(ActiveTab.getData('TabName') === "CandleTray")
                    {
                        PlaceFire(Temp, scene);
                    }
                    scene.CakeGroup.add(Temp);
                }

                else //this means moved or dragged
                {
                    scene.SetItemData.SetItemData(Temp,SentObjects.Original,ActiveTab,"Move");
                }
            }

            else
            {
                if (ActionType === "null")
                {
                    //console.log(Temp);
                    scene.Animations.TweenItemToTray(Temp,SentObjects.Original);
                    if (ActiveTab.getData('TabName') === "IcingTray")
                    {
                        //console.log("Nullified");
                        scene.Icing = 'null';
                    }
                }

                else
                {
                    // if (ActiveTab.getData('TabName') === "IcingTray")
                    // {
                    //     //console.log("Nullified");
                    //     console.log("Nulled it");
                    //     scene.Icing = 'null';
                    // }
                    scene.SetItemData.MoveBackLogClear(Temp);
                }
            }

            function IcingPlacement(Icing,Cake)
            {
                const CakeCenterTop = Cake.getTopCenter();
                const IcingNumber = (Number(Icing.frame.name.slice(-1))-1);
                //console.log(IcingNumber);
                var Placement = 
                [   
                    [0,97],
                    [.5,72],
                    [1,67],
                    [.5,69],
                    [.5,84],
                    [-5.5,67],
                    [.5,94]
                ];

                Icing.setDepth(Icing.scene.DepthList.Icing);

                Icing.x = CakeCenterTop.x + (Placement[IcingNumber][0]);
                Icing.y = CakeCenterTop.y + (Placement[IcingNumber][1]);
            }

            function NormalCheck(Temp,Constrain)
            {
                const obkeys = Object.keys(Constrain);
                const TempBounds = Temp.getBounds();
                var ConstraintBounds;
                var Passed = true;

                for(let i = 1; i < obkeys.length;i++)
                {
                    ConstraintBounds = Constrain[obkeys[i]].getBounds();
                    if (Phaser.Geom.Rectangle.Overlaps(TempBounds,ConstraintBounds))
                    {
                        i = 10;
                        Passed = false;
                    }

                };

                return Passed;
            }

            function PlaceFire(Temp, scene)
            {
                const FireNumber = Number(Temp.frame.name.slice(-1));
                const Fire = scene.addImage(Temp.x,Temp.y - (Temp.height/2), "Candles/Cndl_Fire_" + FireNumber);
                Temp.setData('Fire', Fire);

                if (FireNumber != 8)
                {
                    Fire.setOrigin(.5,1);
                    scene.Animations.CandleFireIdleTween(Fire);
                }
                else
                {
                    Fire.setOrigin(.45,.49);
                    Fire.x -= 1;
                    scene.addRepeatingEvent(100,()=>
                    {
                        //console.log("Speed is 180");
                        Fire.setRotation(Math.random());
                    },-1);
                }
                Fire.setDepth(scene.DepthList.Fire);
                scene.CakeGroup.add(Fire);
            }

    

            return Passed;
        }
}